import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHomePage ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            {/* Logo removed */}
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link 
              to="/" 
              className={`text-base font-medium transition-colors ${
                isScrolled || !isHomePage 
                  ? 'text-[#1A2332] hover:text-[#C4704B]' 
                  : 'text-white hover:text-white/80'
              }`}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className={`text-base font-medium transition-colors ${
                isScrolled || !isHomePage 
                  ? 'text-[#1A2332] hover:text-[#C4704B]' 
                  : 'text-white hover:text-white/80'
              }`}
            >
              About
            </Link>
            <Link 
              to="/services" 
              className={`text-base font-medium transition-colors ${
                isScrolled || !isHomePage 
                  ? 'text-[#1A2332] hover:text-[#C4704B]' 
                  : 'text-white hover:text-white/80'
              }`}
            >
              Services
            </Link>
            <Link 
              to="/contact" 
              className={`px-6 py-2 rounded-lg text-base font-medium transition-all whitespace-nowrap ${
                isScrolled || !isHomePage 
                  ? 'bg-[#C4704B] text-white hover:bg-[#A85A3A]' 
                  : 'bg-white text-[#1A2332] hover:bg-white/90'
              }`}
            >
              Contact
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-8 h-8 flex items-center justify-center ${
              isScrolled || !isHomePage ? 'text-[#1A2332]' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 bg-white rounded-lg shadow-lg">
            <div className="flex flex-col space-y-4 px-6 py-4">
              <Link 
                to="/" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-base font-medium text-[#1A2332] hover:text-[#C4704B] transition-colors"
              >
                Home
              </Link>
              <Link 
                to="/about" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-base font-medium text-[#1A2332] hover:text-[#C4704B] transition-colors"
              >
                About
              </Link>
              <Link 
                to="/services" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-base font-medium text-[#1A2332] hover:text-[#C4704B] transition-colors"
              >
                Services
              </Link>
              <Link 
                to="/contact" 
                onClick={() => setIsMobileMenuOpen(false)}
                className="inline-block text-center bg-[#C4704B] text-white px-6 py-2 rounded-lg text-base font-medium hover:bg-[#A85A3A] transition-colors whitespace-nowrap"
              >
                Contact
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
